import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleEdit"><Path d="M12 10.5C14.2091 10.5 16 8.70914 16 6.5C16 4.29086 14.2091 2.5 12 2.5C9.79086 2.5 8 4.29086 8 6.5C8 8.70914 9.79086 10.5 12 10.5Z" stroke="currentColor"/><Path d="M16 13.5703C14.8233 12.8896 13.4571 12.5 12 12.5C7.58172 12.5 4 16.0817 4 20.5H11" stroke="currentColor"/><Path d="M13.5 21.5V19.5L19.5 13.5L21.5 15.5L15.5 21.5H13.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleEdit;
